import { StepSection } from './step-section';

export class StepState {
  constructor(
    public allSteps: number,
    public step: number,
    public stepHidden: boolean,
    public withNumbering: boolean,
    public useSections: boolean,
    public onboardingSections: StepSection[],
    public isOnboarding: boolean,
    public sectionsWithCheckmarks: boolean,
    public useSeparateSections: boolean,
  ) {}
}
